define("shared/utils/media-adjustments/merge-media-adjustments", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.mergeMediaAdjustmentsPayload = mergeMediaAdjustmentsPayload;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  function mergePlatformAdjustment(existing, incoming, options) {
    const existingPreview = existing?.preview;
    const incomingPreview = incoming.preview;
    if (existingPreview?.status === 'processing' && incomingPreview.status === 'not_requested') {
      return {
        ...incoming,
        preview: existingPreview
      };
    }
    if (options.preserveResolvedViolations && incomingPreview.status === 'not_needed' && incoming.violations.length === 0 && existing && existing.violations.length > 0) {
      return {
        ...existing,
        preview: incomingPreview
      };
    }
    return incoming;
  }
  function mergeMediaAdjustmentsPayload(existing, incoming) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!existing?.platforms) {
      return incoming;
    }
    if (!options.preserveResolvedViolations && Object.keys(incoming.platforms).length === 0) {
      return incoming;
    }
    const platforms = {
      ...existing.platforms,
      ...incoming.platforms
    };
    Object.entries(incoming.platforms).forEach(_ref => {
      let [platformKey, adjustment] = _ref;
      platforms[platformKey] = mergePlatformAdjustment(existing.platforms[platformKey], adjustment, options);
    });
    return {
      platforms
    };
  }
});